import { useState } from "react";
import { authService } from "../../services/authService";

export const useOTP = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * درخواست ارسال کد OTP یکبار مصرف
   * @param {string} phone - شماره موبایل ۱۱ رقمی کاربر
   * @param {string} purpose - هدف ارسال ('register', 'login', 'reset_password')
   */
  const requestOTP = async (phone, purpose) => {
    setLoading(true);
    setError(null);
    try {
      const response = await authService.requestOTP(phone, purpose);
      return response; // حاوی داده‌های دریافتی شامل زمان انقضا
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    requestOTP,
    loading,
    error,
  };
};
